module.exports = __webpack_public_path__ + "static/assets/mywellfie-full-logo.png";